export default __webpack_public_path__ + "static/media/cancel.fca50269.svg";